<template>
  <div class="liu">
    <!-- 主页面 -->
    <div class="retail-business-examine">
      <!-- title -->
      <mt-header fixed title="小微商户" class="title1 no-roll">
        <mt-button slot="left" v-show="isCanSelectedProduct" @click="visible.product = true">产品</mt-button>
        <mt-button slot="right" @click="visible.search = true">更多</mt-button>
      </mt-header>
      <!-- container -->
      <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
        <!-- 提示行 -->
        <!-- 如果有tips提示信息，此div样式要用class="tips-box" -->
        <div />
        <!-- 空页 -->
        <div v-if="isEmptyData"></div>
        <!-- 任务列表 -->
        <div v-if="isHasData">
          <div class="retail-business" v-for="(item, index) in myData.list" :key="index" @click="onRowClick(item.id, item.status)">
            <div class="business-name"> {{ item.userShortName }}_{{ item.account | accountText }} </div>
            <div class="business-info">
              <div class="info-name">商户名称 {{ item.userName }}({{ item.userMobile }})</div>
              <div class="info-state">{{ item.status | statusText }}</div>
            </div>
          </div>
        </div>
        <!-- 无数据占位图 -->
        <div v-if="isNoData">
          <div class="no-data">
            <img src="../assets/bitmap_agent@3x.png" width="60%" />
            <div class="title-5" v-if="myParam.productAgentId">当前暂无小微商户信息</div>
            <div class="title-5" v-else>{{ emptyStartDate + " - " + emptyEndDate + " 暂无小微商户信息" }}</div>
            <div class="title-5"> 点击右上角<span @click="visible.search = true">更多</span> 查看更多小微商户信息 </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品筛选页面  -->
    <mt-popup class="search-popup" v-model="visible.product" position="left" :modal="false">
      <mt-header fixed title="选择产品" class="title2">
        <mt-button slot="left" icon="back" @click="visible.product = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <div class="result-list">
            <div class="list-row">
              <div class="list-item" v-for="(item, index) in search.product.list" :key="index" @click="onSearchProductListItemClick(item)">
                <span>{{ item.name }}</span>
                <svg-icon :icon-class="selectedProductSvgPath(item)" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mt-popup>
    <!-- 查询条件筛选页面 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2" />
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 代理商名 -->
          <div class="content-box" v-show="false">
            <div>
              <span>代理商名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="search.agent.selected" placeholder="请选择代理商名称或手机号" readonly @click="onSearchAgentClick" />
              <img v-show="!search.agent.empty" :src="require('@/assets/clear.png')" alt @click="onSearchAgentClearClick" />
            </div>
          </div>
          <!-- 商户名 -->
          <div class="content-box">
            <div>
              <span>商户名称或手机号</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="search.user.selected" placeholder="请选择商户名称或手机号" readonly @click="onSearchUserClick" />
              <img v-show="!search.user.empty" :src="require('@/assets/clear.png')" alt @click="onSearchUserClearClick" />
            </div>
          </div>
          <!-- 商户简称 -->
          <div class="content-box">
            <div>
              <span>商户简称</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="myParam.userShortName" placeholder="请输入商户简称" :readonly="disabled.userShortName" />
            </div>
          </div>
          <!-- 小微ID -->
          <div class="content-box" v-show="false">
            <div>
              <span>小微ID</span>
            </div>
            <div>
              <input type="text" class="name-mobile w56" v-model="myParam.merChantId" placeholder="请输入小微ID" />
            </div>
          </div>
          <!-- 状态 -->
          <div class="content-box" v-show="false">
            <div>
              <span>状态</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.status === item.value }" v-for="(item, index) in search.status.list" :key="index" @click="myParam.status = item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 账户类型 -->
          <div class="content-box" v-show="false">
            <div>
              <span>账户类型</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.accountType === item.value }" v-for="(item, index) in search.accountType.list" :key="index" @click="myParam.accountType = item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 是否绑定标签 -->
          <div class="content-box" v-show="false">
            <div>
              <span>是否绑定标签</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.bindTagStatus === item.value }" v-for="(item, index) in search.bindTagStatus.list" :key="index" @click="myParam.bindTagStatus = item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <!-- 添加时间 -->
          <div class="content-box">
            <div>
              <span>添加时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">
                {{ picker.startDateText }}
              </span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">
                {{ picker.endDateText }}
              </span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchCancelBtnClick">取消</span>
          <span class="blue" @click="onSearchSubmitBtnClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 代理商名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.agent" position="right" :modal="false">
      <mt-header fixed title="选择代理商" class="title2">
        <mt-button slot="left" icon="back" @click="visible.agent = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <div class="result-list">
            <div class="list-row">
              <div class="list-item" v-for="(item, index) in search.agent.list" :key="index" @click="onSearchAgentListItemClick(item)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </mt-popup>
    <!-- 商户名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.user" position="right" :modal="false">
      <div class="search-content">
        <mt-header fixed title="选择商户" class="title2">
          <mt-button slot="left" icon="back" @click="visible.user = false">返回</mt-button>
        </mt-header>
        <div>
          <form action="" v-on:submit.prevent="">
            <mt-search v-model="search.user.key" @keyup.enter.native="onSearchUserListKeyup" cancel-text="取消" placeholder="输入商户姓名或手机号" :show="true">
              <div class="result-list">
                <div class="list-row">
                  <div class="list-item" v-for="(item, index) in search.user.list" :key="index" @click="onSearchUserListItemClick(item)">
                    <span>{{ item.name + " " + item.mobile }}</span>
                  </div>
                </div>
              </div>
            </mt-search>
          </form>
        </div>
      </div>
    </mt-popup>
    <!-- 日期选择 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm"></mt-datetime-picker>
  </div>
</template>

<script>
/* global appid */

import { GetToken, GetXWSHAuditList, GetProduct_ComboBox, GetProductAgent_ComboBox, GetUserList_Combox, GetWorkWXOpenid, LoginByWorkWXOpenid } from '@/api/manage';
import { SucceedHandle2, SucceedHandle3, NotSucceedHandle } from '@/api/handle';
import { CusToast } from '@/utils/CustomToast';
import { Indicator } from 'mint-ui';
import { formatDate } from '@/utils/utils';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'RetailBusinessExamineList',
  comments: { SvgIcon },
  data() {
    return {
      // 列表信息
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        accountType: -1,
        bindTagStatus: -1,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        productAgentId: '',
        userId: '',
        userShortName: '',
        startDate: '',
        endDate: '',
        merChantId: '',
        flag: 1,
        findDateType: 1,
        type: 1,
      },
      // 查询数据
      search: {
        // 产品名
        product: {
          list: [],
        },
        // 代理商名
        agent: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 商户名
        user: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 状态
        status: {
          list: [
            { name: '全部', value: -2 },
            { name: '待审核', value: 0 },
            { name: '正常 ', value: 1 },
            { name: '禁用 ', value: 2 },
            { name: '审核失败 ', value: -1 },
          ],
        },
        // 账户类型
        accountType: {
          list: [
            { name: '全部', value: -1 },
            { name: '小微商户', value: 1 },
            { name: '标准商户 ', value: 2 },
          ],
        },
        // 是否绑定标签
        bindTagStatus: {
          list: [
            { name: '全部', value: -1 },
            { name: '未绑定', value: 0 },
            { name: '已绑定 ', value: 1 },
          ],
        },
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
        product: false,
        agent: false,
        user: false,
      },
      // 有效性状态
      disabled: {
        userShortName: false,
        startDateText: false,
        endDateText: false,
      },
      code: '',
      openid: '',
      appid: appid.qy_weixin_id,
      wxLoginOk: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'RetailBusinessExamineEdit') {
      this.$store.commit('setCache', 'RetailBusinessExamineList');
    } else {
      this.$store.commit('delCache', 'RetailBusinessExamineList');
    }
    next();
  },
  mounted() {
    this.$nextTick(() => {
      if (sessionStorage.getItem('bindStatus') === 'ok') {
        this.initData();
      } else {
        const code = this.getUrlKey('code');
        if (code) {
          this.code = code;
          this.bindAndInitData();
        } else {
          // 传随机数为了让微信不缓存此页面
          this.getCodeApi(Math.floor(Math.random() * 900000 + 100000));
        }
      }
    });
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isEmptyData() {
      return this.myData.total === -1;
    },
    isHasData() {
      return this.myData.total > 0;
    },
    isNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    selectedProductSvgPath() {
      return item => (item.selected ? 'selected_coupons' : 'unselected_coupons');
    },
    isCanSelectedProduct() {
      return this.search.product.list.length > 1;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶1
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      Indicator.open();
      this.getProductComboBox(() => {
        this.getDateBase(() => {
          this.getMyData();
        });
      });
    },
    // 绑定并加载数据
    bindAndInitData() {
      // 滚动条置顶1
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      Indicator.open();
      this.getWorkWXOpenid(() => {
        // this.openid = "owFSv1KL2MUow-2fD-4UdbttZDx4";
        this.getToken(() => {
          this.loginByWorkWXOpenid(() => {
            if (this.wxLoginOk === 0) {
              sessionStorage.setItem('bindStatus', 'ok');
              this.getProductComboBox(() => {
                this.getDateBase(() => {
                  this.getMyData();
                });
              });
            } else {
              this.$router.push({
                path: '/retailbusinessexamineregister',
                query: { openid: this.openid },
              });
            }
          });
        });
      });
    },
    // 获取url中参数
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
    },
    // 微信交互，获取code
    getCodeApi(state = '') {
      const appid = this.appid;
      const reUrl = encodeURIComponent(window.location.href);
      const scope = 'snsapi_base'; // snsapi_userinfo   //静默授权 用户无感知
      const url = ` https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${reUrl}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.replace(url);
    },
    // 接口获取openid
    getWorkWXOpenid(ok = null) {
      GetWorkWXOpenid({ code: this.code })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.data.openId) {
                this.openid = res.data.openId;
                ok && ok();
              } else {
                CusToast('没有获取到OPENID');
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 用openid登录
    loginByWorkWXOpenid(ok = null) {
      LoginByWorkWXOpenid({ openid: this.openid })
        .then(res => {
          SucceedHandle3(
            res.code,
            res.innerCode,
            res.msg,
            () => {
              this.wxLoginOk = res.data.wxBindingStatus;
              ok && ok();
            },
            (code, innerCode, msg) => {
              Indicator.close();
              if (innerCode === 1001) {
                this.wxLoginOk = 1;
                ok && ok();
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 获取token
    getToken(ok = null) {
      GetToken()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              localStorage.setItem('token', res.msg);
              ok && ok();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
    // 获取产品列表
    getProductComboBox(ok = null) {
      GetProduct_ComboBox()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                this.search.product.list = res.rows;
                this.search.product.list.forEach(item => (item.selected = false));
                const defaultProduct = this.search.product.list[0];
                defaultProduct.selected = true;
                localStorage.setItem('productid', defaultProduct.id);
              } else {
                localStorage.setItem('productid', '');
              }
              ok && ok();
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message || err.msg);
          msg && CusToast(msg);
        });
    },
    // 获取审核列表
    getMyData() {
      // Indicator.open();
      // 先设置禁止滚动加载数据等查询条件
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      GetXWSHAuditList(this.myParam)
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 行单击事件
    onRowClick(id, status) {
      if (status !== 0) {
        CusToast('只有待审核的才可以审核');
        return;
      }
      this.$router.push({
        path: '/retailbusinessexamineedit',
        query: { id },
      });
    },
    // 查询搜索单击确定事件
    onSearchSubmitBtnClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 8. 加载数据
      this.getMyData();
    },
    // 查询搜索单击取消事件
    onSearchCancelBtnClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 置空所有筛选窗口数据
    clearSearchData() {
      this.search.agent.key = '';
      this.search.agent.selected = '';
      this.search.agent.empty = true;
      this.search.user.key = '';
      this.search.user.selected = '';
      this.search.user.empty = true;
      this.myParam.status = 0;
      this.myParam.userShortName = '';
      this.myParam.merChantId = '';
      this.myParam.flag = 1;
      this.myParam.findDateType = 1;
      this.myParam.type = 1;
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
    },
    // ******************************** 产品筛选相关代码 ********************************
    // 代理商列表选中商户名称事件
    onSearchProductListItemClick(item) {
      this.$nextTick(() => {
        this.search.product.list.forEach(item => (item.selected = false));
        item.selected = true;
        localStorage.setItem('productid', item.id);
        this.visible.product = false;
        window.scrollTo(0, 0);
        this.myData.list = [];
        Indicator.open();
        this.getMyData();
      });
    },
    // ******************************** ********************** ********************************
    // ******************************** 代理商筛选相关代码 ********************************
    // 筛选窗口代理商名称点击事件
    onSearchAgentClick() {
      this.getAgentListBox('', () => {
        this.visible.agent = true;
        this.search.agent.key = '';
      });
    },
    // 清空筛选框中代理商名称的事件
    onSearchAgentClearClick() {
      this.search.agent.empty = true;
      this.search.agent.selected = '';
      this.myParam.productAgentId = '';
    },
    // 代理商列表选中商户名称事件
    onSearchAgentListItemClick(item) {
      this.search.agent.empty = false;
      this.search.agent.selected = `${item.label}`;
      this.myParam.productAgentId = item.value;
      this.visible.agent = false;
    },
    // 交互后返回代理商列表
    getAgentListBox(nameOrMobile, callback = null) {
      Indicator.open();
      GetProductAgent_ComboBox({ productID: localStorage.getItem('productid'), showType: 1, statusType: 0 })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.search.agent.list = res.rows;
              document.activeElement.blur();
              callback && callback();
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // ******************************** ********************** ********************************
    // ******************************** 商户筛选相关代码 ********************************
    // 筛选窗口商户名称点击事件
    onSearchUserClick() {
      this.getUserListBox('', () => {
        this.visible.user = true;
        this.search.user.key = '';
      });
    },
    // 清空筛选框中用户名称的事件
    onSearchUserClearClick() {
      this.search.user.empty = true;
      this.search.user.selected = '';
      this.myParam.userId = '';
      // 设置其他查询条件生效
      this.disabled.userShortName = false;
      this.disabled.startDateText = false;
      this.disabled.endDateText = false;
    },
    // 商户名称列表商户名称查询事件
    onSearchUserListKeyup() {
      this.getUserListBox(this.search.user.key);
    },
    // 商户列表选中商户名称事件
    onSearchUserListItemClick(item) {
      this.search.user.empty = false;
      this.search.user.selected = `${item.name} ${item.mobile}`;
      this.myParam.userId = item.id;
      this.visible.user = false;
      // 设置其他查询条件不生效
      this.myParam.userShortName = '';
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
      this.disabled.userShortName = true;
      this.disabled.startDateText = true;
      this.disabled.endDateText = true;
    },
    // 交互后返回商户列表
    getUserListBox(nameOrMobile, callback = null) {
      Indicator.open();
      GetUserList_Combox({
        pageNum: 1,
        pageSize: 50,
        productAgentID: '',
        productID: localStorage.getItem('productid'),
        name: nameOrMobile,
        agentFindType: 3,
        genre: 1,
      })
        .then(res => {
          Indicator.close();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.search.user.list = res.rows;
              document.activeElement.blur();
              callback && callback();
            },
            (code, msg) => {
              Indicator.close();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // ******************************** ******************* ********************************
    // ******************************** 日期筛选相关代码 ********************************
    // 代理商列表日期查询条件
    getDateBase(callback) {
      const nowDate = new Date();
      this.picker.startDateBase = formatDate(new Date().setFullYear(nowDate.getFullYear() - 1));
      this.picker.endDateBase = formatDate(nowDate);
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
      callback && callback();
    },
    // 单击日期事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          if (this.disabled.startDateText) return;
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          if (this.disabled.endDateText) return;
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 日期确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // ******************************** ******************** ********************************
  },
  filters: {
    accountText(val) {
      if (val === '小微商户') return '小微';
      if (val === '标准商户') return '个体';
    },
    statusText(val) {
      if (val === 0) return '待审核';
      if (val === 1) return '正常';
      if (val === 2) return '禁用';
      if (val === -1) return '审核失败';
    },
  },
};
</script>
